import React from 'react';
import { Skeleton } from '../Common/Skeleton';

const ChatListItemsSkeleton = () => {
  return (
    <div className='flex flex-col gap-2'>
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className='flex w-full gap-2 border-b px-2 py-3'>
          {/* Avatar Skeleton */}
          <Skeleton className='h-[48px] w-[48px] rounded-full' />

          <div className='flex-1'>
            {/* Name and Star Row */}
            <div className='mb-2 flex items-center justify-between'>
              <Skeleton className='h-5 w-[120px]' />
              <Skeleton className='h-5 w-5' />
            </div>

            {/* Message Preview and Time */}
            <div className='flex items-center justify-between'>
              <Skeleton className='h-4 w-[200px] sm:w-[220px]' />
              <div className='flex items-center gap-1'>
                <Skeleton className='h-1 w-1 rounded-full' />
                <Skeleton className='h-4 w-[60px]' />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChatListItemsSkeleton; 